/**
 * 转换指定对象的键值为null
 * @param obj 指定对象
 * @param expected 预期要转换为null的值
 */
export function emptyToNull(obj, expected = [null, undefined, '']) {
  Object.keys(obj || {})
      .filter((key) => (expected || []).includes(obj[key]))
      .forEach((key) => { obj[key] = null })
  return obj
}
